import React from "react";

/**
 * One label/value line in a review <dl>. Shared by Step 6's review summary and
 * the sponsor copy — it lived inside Step6Review.tsx until Round 21 moved
 * SponsorCopy into its own file, which would otherwise have needed a second
 * copy of these five lines or a circular import between the two.
 */
export function ReviewRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex gap-2">
      <dt className="text-slate-500 w-40 flex-shrink-0">{label}</dt>
      <dd className="text-slate-900 break-words">{value}</dd>
    </div>
  );
}
